import React from 'react';
import { Box, CircularProgress, Fade, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useOktaAuth } from '@okta/okta-react';
import axios2 from 'axios';
import { DeviceUUID } from 'device-uuid';
import PropTypes from 'prop-types';
import { Suspense, useEffect, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import { Switch, useHistory } from 'react-router-dom';
import routes from 'src/routes';
import { setIpAddress, setSessionToken, setUserSession, setUserSessionFromLocale } from 'src/utils/Common';
import { NavBarAdetleriAl } from 'src/utils/storage/NavBarAdet';
import Topbar from './Topbar';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%',
    width: '100%'
  },
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0
    }
  },
  content: {
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    }
  },
  // YENİ EKLENEN STİL: Tam ekran yükleme katmanı
  splashScreen: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 9999, // En üstte durması için
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff', // Veya theme.palette.background.default
  },
  loadingText: {
    marginTop: theme.spacing(3),
    fontWeight: 500,
    color: theme.palette.text.secondary
  }
}));

function Auth() {
  const classes = useStyles();
  const [Loading, setLoading] = useState(true);
  const [LoadingMessage, setLoadingMessage] = useState("Güvenli bağlantı kuruluyor..."); // Dinamik mesaj için

  const [DeviceId, setDeviceId] = useState("");
  const [IPAdres, setIPAdres] = useState('');
  const history = useHistory();
  const { oktaAuth, authState } = useOktaAuth();

  // Initial Setup: Viewport, IP ve DeviceID
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
    meta.setAttribute('name', 'viewport');
    document.head.appendChild(meta);

    const redirect = setUserSessionFromLocale();
    if (redirect) {
      history.push('/profile/1/timeline');
    }

    const publicIp = require('public-ip');
    (async () => {
      try {
        const ip = await publicIp.v4();
        setIPAdres(ip);
      } catch (e) { logger.error("IP Error", e); }
    })();

    const uuid = new DeviceUUID().get();
    setDeviceId(uuid);
  }, [history]);

  // Auth Logic & Silent Refresh Protection
  useEffect(() => {
    // Okta henüz initialize olmadıysa bekle (Beyaz ekranın ana sebeplerinden biri burasıdır)
    if (!authState) return;

    if (!authState.isAuthenticated) {
      const fromUri = history.createHref(history.location);
      oktaAuth.signInWithRedirect({ originalUri: fromUri });
      return;
    }

    // iPhone Fix
    if (localStorage.getItem('ArtemisApp') === '1' && Loading === false) {
      return;
    }

    if (authState.isAuthenticated) {
      setLoadingMessage("Kullanıcı bilgileri doğrulanıyor..."); // Mesajı güncelle

      oktaAuth.getUser().then(info => {
        if (!info) {
          oktaAuth.signInWithRedirect();
          return;
        }

        const dataUser = [{
          TerminalId: DeviceId.toString() || '1',
          VersionNr: process.env.REACT_APP_VERSION,
          TerminalIp: IPAdres || '1',
          LanguageId: 1
        }];

        const configUser = {
          headers: {
            'Content-Type': 'application/json',
            'IpAddress': 1,
            'max-age': 86400,
            'X-Frame-Options': 'DENY',
            'X-XSS-Protection': '1; mode=block',
            'accessToken': authState.accessToken.accessToken,
            'Authorization': 'Bearer ' + authState.accessToken.accessToken
          }
        };

        let Address = process.env.REACT_APP_API_URL + "/GetUserOkta";

        setLoadingMessage("Uygulama ayarları yükleniyor..."); // API isteği öncesi mesaj

        axios2.post(Address, dataUser, configUser)
          .then((response) => {
            if (!authState.accessToken.accessToken) {
            
              setLoading(false);
              history.push('/Unauthorized');
            } else {
              const userData = response.data[0];
              setSessionToken(authState.accessToken.accessToken, userData?.SessionTokenWs || '');
              setIpAddress(IPAdres);
              setUserSession(authState.accessToken.accessToken, userData?.SessionTokenWs || '', userData);

              // Arka planda verileri kaydet (Await kullanıp bekletmiyoruz, UI açılabilir)
              SavePhoto(authState.accessToken.accessToken);
              SaveMenu(userData?.UserId, authState.accessToken.accessToken);
              NavBarAdetleriAl(userData?.ServiceShopId, userData?.TechnicianId);



              try {
                localStorage.setItem(
                  'ArtemisApp',
                  '1'
                );
              } catch (e) {
                localStorage.removeItem('ArtemisApp');
              }

              sessionStorage.setItem('ArtemisApp', '1');

              setLoading(false);
              history.push('/profile/1/timeline');
            }
          })
          .catch((error) => {
  logger.error("Hata detayı:", error.message);
            setLoading(false);
            history.push('/Unauthorized');
          });
      });
    }
  }, [authState, oktaAuth, history, DeviceId, IPAdres, Loading]);

  const SaveMenu = async (UserId, AuthToken) => {
    // ... (Kodun aynı kalacak) ...
    // Yer kazanmak için burayı kısaltıyorum, senin orijinal kodunla aynı.
    const dataMenu = [{ UserName: UserId }];
    const configMenu = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + AuthToken,
        'SessionToken': AuthToken,
      }
    };
    try {
      let AddressMenu = process.env.REACT_APP_API_URL + "/GetUserMenu";
      const response = await axios2.post(AddressMenu, dataMenu, configMenu);
      const MenuData = response.data.length === 0 ? [] : response.data;
      sessionStorage.setItem('MenuData', JSON.stringify(MenuData));
      try {
        localStorage.setItem(
          'MenuData',
          JSON.stringify(MenuData)
        );
      } catch (e) {
        localStorage.removeItem('MenuData');
      }


    } catch (e) { logger.error("Menu Save Error", e); }
  };

  const SavePhoto = async (AuthToken) => {
    // ... (Kodun aynı kalacak) ...
    const configMenu = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + AuthToken,
        'SessionToken': AuthToken,
      }
    };
    try {
      let Address = process.env.REACT_APP_API_URL + "/GetPhoto";
      const response = await axios2.post(Address, "", configMenu);
      try {
        localStorage.setItem(
          'UserPhoto',
          response.data[0]?.Photo || ""
        );
      } catch (e) {
        localStorage.removeItem('UserPhoto');
      }

    } catch (e) {
      try {
        localStorage.setItem(
          'UserPhoto',
          ""
        );
      } catch (e) {
        localStorage.removeItem('UserPhoto');
      }
    }
  };

  // --- RENDER BÖLÜMÜ ---

  // 1. Durum: Okta henüz yüklenmediyse veya Bizim API işlemlerimiz sürüyorsa
  // Tam ekran Loading göster.
  if (!authState || Loading) {
    return (
      <Fade in={true} timeout={500}>
        <div className={classes.splashScreen}>
          {/* Logo Varsa Buraya Ekleyebilirsin */}
          {/* <img src="/static/logo.png" alt="Logo" style={{ marginBottom: 20, width: 100 }} /> */}

          <CircularProgress size={60} thickness={4} />

          <Box mt={2}>
            <Typography variant="h6" color="textPrimary">
              Lütfen Bekleyiniz
            </Typography>
          </Box>

          <Typography className={classes.loadingText} variant="body2">
            {LoadingMessage}
          </Typography>
        </div>
      </Fade>
    );
  }

  // 2. Durum: Yükleme bitti, uygulama içeriğini göster
  return (
    <>
      <Topbar />
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<CircularProgress />}>
            <Switch>{renderRoutes(routes)}</Switch>
          </Suspense>
        </div>
      </div>
    </>
  );
}

Auth.propTypes = {
  route: PropTypes.object
};

export default Auth;